import React from "react";
import { NavLink } from "react-router-dom";
import ThemeLogo from "../ThemeLogo/ThemeLogo";
import "./AdminBrand.css";

export default function AdminBrand({ variant = "sidebar", onNavigate }) {
  const isSidebar = variant === "sidebar";

  const logo = (
    <ThemeLogo
      alt="AETHRX"
      className={`admin-brand__logo admin-brand__logo--${variant}`}
    />
  );

  if (isSidebar) {
    return (
      <div className="admin-brand admin-brand--sidebar">
        <NavLink to="" end className="admin-brand__link" onClick={onNavigate}>
          {logo}
        </NavLink>
      </div>
    );
  }

  return (
    <NavLink
      to=""
      end
      className="admin-brand admin-brand--header admin-brand__link"
      onClick={onNavigate}
    >
      {logo}
    </NavLink>
  );
}
